<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 구성 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>상품타입</span></th>
                  <td>
                    {{ regData.promise_goods_type }}            
                  </td>
                </tr>
                <tr>
                  <th><span>약속상품명</span></th>
                  <td>
                    {{ regData.promise_goods_nm }}
                  </td>
                </tr>                       
                <tr>
                  <th><span>조제단위</span></th>
                  <td>
                    {{ regData.prepare_unit }}            
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">구성상품명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.item_nm">           
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">구성수량</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.item_quantity">
                  </td>
                </tr>                 
                <tr>
                  <th><span class="emp">처방비용</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.item_price">
                  </td>
                </tr> 
                <tr>
                  <th><span class="emp">상품노출여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="radio" value="Y" v-model="regData.display_yn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="radio" value="N" v-model="regData.display_yn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">노출순서</span></th>
                  <td>
                    <input type="number" class="form_control" placeholder="입력해주세요." v-model="regData.sort_order">
                  </td>
                </tr>                  
              </tbody>
            </table>
            <div class="bottom_box">
                <button class="btn btn_md btn_gray" @click="fn_init_item">초기화</button>
                <button class="btn btn_md btn_darkblue" @click="fn_reg_promise_goods_item">추가</button>
            </div>
          </div>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <!-- <button class="btn btn_md btn_darkblue" @click="fn_move_promiseReg">신규 상품</button> -->
            </div>
            <table class="list">
              <thead>
                <tr>
                  <th>약속상품명</th>
                  <th>상품타입</th>
                  <th>조제단위</th>
                  <th>구성상품명</th>
                  <th>구성수량</th>
                  <th>처방비용</th>
                  <th>노출여부</th>
                  <th>삭제</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="promiseGoodsItemList.length == 0">
                    <td colspan="8"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in promiseGoodsItemList" :key="index">
                  <td @click="fn_mod_item(item)"><span>{{ regData.promise_goods_nm }}</span></td>
                  <td @click="fn_mod_item(item)"><span>{{ regData.promise_goods_type }}</span></td>
                  <td @click="fn_mod_item(item)"><span>{{ regData.prepare_unit }}</span></td>
                  <td @click="fn_mod_item(item)"><span>{{ item.item_nm }}</span></td>
                  <td @click="fn_mod_item(item)"><span>{{ item.item_quantity }}</span></td>
                  <td @click="fn_mod_item(item)"><span>{{ item.item_price }}</span></td>
                  <td @click="fn_mod_item(item)"><span>{{ item.display_yn }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_delete_item(item.goods_seq)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo" v-show="pagingShow"/>
          </div>
        </section>
        <div class="bottom_box">
          <button class="btn btn_md btn_outline"  @click="fn_move_page">목록</button>
        </div>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from "@/mixin/commonUtil";
  import Pagination from "@/components/AdminPagination.vue"

  export default {
    name: 'PromiseGoodsReg',
    mixins: [commonUtil],
    components: {
      Pagination
    },



    data() {
      return {
        goodsTypeList : [],       // 상품타입 리스트
        packageUnitList : [],      // 포장단위 리스트
        regData : {
          promise_goods_cd : '',
          promise_goods_nm : '',
          promise_goods_type : '',
          prepare_unit : '',
          goods_seq : '',
          promise_goods_item_nm : '',
          item_quantity : '',
          display_yn : 'Y',
          item_price : 0,
          sort_order : '',
          status : ''
        },
        pagingShow : false,
        searchInfo : {
          promise_goods_cd : '',
          pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
          }                
        },
        promiseGoodsItemList : []
      }
    },
    async created(){

      let promiseGoodsInfo= this.$store.getters['promise/getPromiseGoodsInfo'];  
    
      this.regData.promise_goods_cd = promiseGoodsInfo.promise_goods_cd;
      this.regData.promise_goods_nm = promiseGoodsInfo.promise_goods_nm;
      this.regData.promise_goods_type = promiseGoodsInfo.promise_goods_type_nm;
      this.regData.prepare_unit = promiseGoodsInfo.prepare_unit_nm;

      this.searchInfo.promise_goods_cd = promiseGoodsInfo.promise_goods_cd;
      console.log("@@@@ this.searchInfo.promise_goods_cd : "+this.searchInfo.promise_goods_cd );
    },
    mounted(){
      this.fn_search();
    },
    methods : {
      fn_search(){
          console.log("@@@ search : %o",this.searchInfo);
          axios
            .post("/api/admin/promise/searchPromiseGoosItemList", this.searchInfo)
            .then((res) => {
                console.log("@@@@ res : %o",res);
                this.promiseGoodsItemList = res.data.promiseItemList;

                console.log("@@@@ promiseList : %o",this.promiseList);

                this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                }                        

        })
        .catch((err) => console.log(err));
      },
      fn_reg_promise_goods_item(){

        if(this.fn_validation_chk()){

            axios
                .post("/api/admin/promise/regPromiseGoodsItem", this.regData)
                .then((res) => {                            
                    console.log("@@@@ res : %o",res);
                    if(res.data.result == "ok"){
                        // let msg = "저장되었습니다";
                        // this.fn_open_alert(msg);
                        alert("저장되었습니다.");
                        this.fn_init_item();
                        this.fn_search();  
                    }else{
                        alert("res.data.errorMsg.");
                    } 
                    
                })
                .catch((err) => console.log(err));
        }
        
      },
      fn_validation_chk(){
        if(this.regData.item_nm == ''){
            alert("구성상품명을 입력해주세요");    
            return false;
        }

        if(this.regData.item_quantity == ''){
            alert("구성상품 수량을 입력해주세요");    
            return false;
        }else if(this.regData.item_quantity < 0){
            alert("구성상품 수량을 0보다 크게 입력해주세요");    
            return false;
        }

        if(this.regData.item_price == ''){
            alert("구성상품 가격을 입력해주세요");    
            return false;
        }else if(this.regData.item_price < 0){
            alert("구성상품 가격을 0보다 크게 입력해주세요");    
            return false;
        }

        return true;
      },
      fn_move_page(){
            this.$router.push("/admin/promise/promiseGoodsItemList");
      },
      fn_mod_item(item){
        this.regData.goods_seq = item.goods_seq;
        this.regData.item_quantity = item.item_quantity;
        this.regData.item_price = item.item_price;
        this.regData.item_nm = item.item_nm;
        this.regData.display_yn = item.display_yn;
        this.regData.sort_order = item.sort_order;
        this.regData.status = "M";
      },
      fn_init_item(){
        this.regData.goods_seq = "";
        this.regData.item_quantity = 0;
        this.regData.item_price = 0;
        this.regData.item_nm = "";
        this.regData.display_yn = "Y";
        this.regData.sort_order = "";
        this.regData.status = "M";
      },
      fn_delete_item(seq){

            let param = new Object();
            param.promise_goods_cd = this.regData.promise_goods_cd;
            param.goods_seq = seq;

            axios
                .post("/api/admin/promise/deletePromiseGoodsItem", param)
                .then((res) => {                            
                    if(res.data.result == "ok"){
                        // let msg = "저장되었습니다";
                        // this.fn_open_alert(msg);
                        alert("삭제되었습니다.");
                        this.fn_init_item();
                        this.fn_search();  
                    }else{
                        alert("res.data.errorMsg.");
                    } 
                    
                })
                .catch((err) => console.log(err));
        }
    }
  }
</script>